<template>
  <div>
    <!-- 修改手机号 -->
    <Head show=" " :goBack="true" :title="userInfo.phone?'修改手机号':'绑定手机号'"></Head>
    <div class="content">
      <div class="content_box">
        <div class="df_a" v-if="userInfo.phone">
          <div class="df_left">手机号：</div>
          <div class="df_right">{{userInfo.phone|FilterPhoneNumber}}</div>
        </div>
        <van-cell-group v-else>
          <van-field
            v-model="mobile"
            label="手机号："
            center
            placeholder="请输入手机号"
            :disabled="disabled"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="mobilecode"
            center
            label="短信验证："
            placeholder="请输入短信验证码"
          >
            <van-button
              slot="button"
              size="small"
              type="primary"
              class="get-code"
              @click="getlogin"
              :disabled="disabled"
            >{{btnText}}</van-button>
          </van-field>
        </van-cell-group>
         <van-cell-group v-if="userInfo.phone">
          <van-field
            v-model="newmobile"
            label="新手机号："
            center
            placeholder="请输入新手机号"
          />
        </van-cell-group>
      </div>
      <!-- 确认修改 -->
      <van-button type="info"  class="info-btn" @click="modification">{{userInfo.phone?'绑定':'确认'}}</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
export default {
  name:"mobile",
  components: {},
  data() {
    return {
      mobilecode: "",
      isAmend: false,
      mobile:"",
      newmobile:"",
      disabled: false,
      totalCount: 0,
      timeName:null
    };
  },
  mounted () {
  },
  computed: {
    btnText() {
      return this.totalCount !== 0 ? `${this.totalCount}秒获取` : "获取验证码";
    }
  },
  beforeDestroy() {
    clearInterval(this.timeName);
  },
  methods: {
    // 确认修改
    modification() {
      if(this.userInfo.phone==true){
          let datas = {
          phone:this.newmobile,
          code:this.mobilecode,
        }
        this.$api.login.userBindPhone(datas).then((res)=>{
          if(res.code==200){
            Toast(res.msg);
            this.getUserInfo()
          }else{
            Toast(res.msg);
          }
        })
      }else{
        let data = {
          phone:this.mobile,
          code:this.mobilecode,
        }
        this.$api.login.userBindPhone(data).then((res)=>{
          if(res.code==200){
            Toast(res.msg);
            this.getUserInfo()
          }else{
            Toast(res.msg);
          }
        })
      }
    },
    getUserInfo(){
      this.$api.login.getUserInfo().then((res)=>{
        if(res.code==200){
          let objStr = JSON.stringify(res.userInfo)
          localStorage.setItem("userInfo",[objStr]);
          this.$router.push({ name: "personal" });
        }else{
          Toast(res.msg);
        }
      })
    },
    // 发送短信
    getlogin() {
        if(this.userInfo.phone){
          this.mobile=this.userInfo.phone
        }
        if (this.mobile) {
          if(/^1[0-9]{10}$/.test(this.mobile)){
            let data = {
                phone:this.mobile,
              }
            if(this.userInfo.phone==false){
                data.type=1
            }
            this.$api.login.userBindCode(data).then((res)=>{
                if(res.code==200){
                  Toast("发送成功");
                  this.getCode();
                }else{
                  Toast(res.msg);
                }
            })
          }else{
            Toast("请输入正确格式的手机号");
          }
        } else {
          Toast("请输入手机号码");
        }
      
    },
    // 倒计时
    getCode() {
      this.disabled = true;
      this.totalCount = 60;
      this.timeName= setInterval(() => {
        this.totalCount--;
        if (this.totalCount === 0) {
          clearInterval(this.timeName);
          this.disabled = false;
        }
      }, 1000);
    },
  }
};
</script>

<style scoped>
.content {
  text-align: center;
  padding-top: 100px;
  background-color: #fff;
}
.van-button--normal {
  font-size: 28px;
  width: 690px;
  height: 80px;
  color: #fff;
  background-color: #13A556;
  border: 1px solid #15c466;
  line-height: 80px;
}
.content_box {
  margin-bottom: 30px;
  background: #fff;
}
.content /deep/ .van-field__label span {
  display: block;
  text-align: left;
}
.van-cell {
  font-size: 26px;
  padding: 0 30px;
  height:80px;
  border-bottom: 1px solid #efefef;
  line-height:80px;
}
.df_a {
  display: flex;
  padding: 0 30px;
  border-bottom: 1px solid #efefef;
  font-size: 26px;
  line-height: 80px;
  text-align: left;
}
.df_left {
  width: 164px;
}
.van-button--small {
  width: 142px;
  height: 50px;
  font-size: 20px;
  line-height: 50px;
}
.van-button--primary {
  color: #fff;
  width: 180px;
  background-color: #13A556;
  border: 1px solid #15c466;
}
</style>